import { useLocation } from 'react-router-dom';
import { useEffect } from 'react'; 
import { getAppUrlInfo } from '../utils/urls';

// More accurate match function
const findMatchingRoute = (pathname: string, appRoutes: Array<any>) => {
  // Sort by longest path first to ensure specific match before generic '/'
  const sortedRoutes = [...appRoutes].sort((a, b) => b.path.length - a.path.length);

  return sortedRoutes.find((route) => {
    const basePath = route.path.replace(/:id/g, ''); // Remove dynamic part
    return pathname.startsWith(basePath);
  });
};

export const usePageTitle = (appRoutes: Array<any>) => {
  const { name } = getAppUrlInfo();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;

    const matchedRoute = findMatchingRoute(pathname, appRoutes);

    document.title = `PL-${name}${matchedRoute ? ' | ' + matchedRoute.title : ''}`;
  }, [location.pathname, appRoutes]);
};
